/**
 * -------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation.  All Rights Reserved.  Licensed under the MIT License.
 * See License in the project root for license information.
 * -------------------------------------------------------------------------------------------
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BetaGraph } from '../BetaGraph';
import { prepScopes } from '../utils/GraphHelpers';
/**
 * async promise, allows developer to get my presense
 *
 * @returns {Promise<Presence>}
 * @memberof BetaGraph
 */
export function getMyPresence(graph) {
    return __awaiter(this, void 0, void 0, function* () {
        const betaGraph = BetaGraph.fromGraph(graph);
        const scopes = 'presence.read';
        const result = yield betaGraph
            .api('/me/presence')
            .middlewareOptions(prepScopes(scopes))
            .get();
        return result;
    });
}
/**
 * async promise, allows developer to get user presense
 *
 * @returns {Promise<Presence>}
 * @memberof BetaGraph
 */
export function getUserPresence(graph, userId) {
    return __awaiter(this, void 0, void 0, function* () {
        const betaGraph = BetaGraph.fromGraph(graph);
        const scopes = ['presence.read', 'presence.read.all'];
        const result = yield betaGraph
            .api(`/users/${userId}/presence`)
            .middlewareOptions(prepScopes(...scopes))
            .get();
        return result;
    });
}
/**
 * async promise, allows developer to get person presense by providing array of IDynamicPerson
 *
 * @returns {}
 * @memberof BetaGraph
 */
export function getUsersPresenceByPeople(graph, people) {
    return __awaiter(this, void 0, void 0, function* () {
        if (!people || people.length === 0) {
            return {};
        }
        const betaGraph = BetaGraph.fromGraph(graph);
        const batch = betaGraph.createBatch();
        for (const person of people) {
            if (person !== '' && person.id) {
                const id = person.id;
                batch.get(id, `/users/${id}/presence`, ['presence.read', 'presence.read.all']);
            }
        }
        try {
            const peoplePresence = yield batch.execute();
            return peoplePresence;
        }
        catch (_) {
            try {
                const peoplePresence = {};
                const response = yield Promise.all(people.filter(person => person && person.id).map(person => getUserPresence(betaGraph, person.id)));
                for (const r of response) {
                    peoplePresence[r.id] = r;
                }
                return peoplePresence;
            }
            catch (_) {
                return null;
            }
        }
    });
}
//# sourceMappingURL=graph.presence.js.map